export default "__VITE_ASSET__87ed4329__"